import React, { useState } from "react";
import "../../../../../css/CashflowModeller2/Inputs/DownloadButton.css";

/**
 * DownloadButton component renders a customizable button for download actions.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.buttonText - The text to display on the button.
 * @param {boolean} props.isActive - Indicates if the button is in an active (clicked) state.
 * @param {function} props.onClick - Callback function to handle button click events.
 * @param {boolean} props.disabled - If true, disables the button.
 * @param {boolean} [props.showTooltip=false] - If true, displays a tooltip on hover.
 * @param {React.ReactNode} props.children - Optional children to render inside the button.
 * @returns {JSX.Element} The rendered DownloadButton component.
 */
const DownloadButton = ({
  buttonText,
  isActive,
  onClick,
  disabled,
  showTooltip = false,
  children,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="tooltip-button-wrapper">
      <div
        className={`DownloadButton ${isActive ? "clicked" : ""} ${
          disabled ? "disabled" : ""
        }`}
        onClick={onClick}
      >
        <div className="Label">{buttonText}</div>
      </div>
    </div>
  );
};

export default DownloadButton;
